export default "__VITE_ASSET__BR6N_jn4__"